export const clientFromDto = (dto) => ({
  id: dto.id,
  documentType: dto.document_type,
  documentNumber: dto.document_number,
  firstName: dto.first_name,
  lastName: dto.last_name,
  dateOfBirth: dto.birthday_date,
  gender: dto.gender,
  phoneNumber: dto.phone_number,
  email: dto.email,
  softsegurosId: dto.softseguros_id,
});

export const clientToDto = (data) => ({
  document_type: data.documentType,
  document_number: data.documentNumber,
  first_name: data.firstName,
  last_name: data.lastName,
  birthday_date: data.dateOfBirth,
  gender: data.gender,
  phone_number: data.phoneNumber,
  email: data.email,
  softseguros_id: data.softsegurosId,
})